import { BaseFetch } from "../main-model";
export default class ExportPP5Model extends BaseFetch {
  getExportPP5By = (data) =>
    this.authFetch({
      url: "export-pp5/getExportPP5By",
      method: "POST",
      body: JSON.stringify(data),
    });
    getCheckTimeSubjectPP5By = (data) =>
    this.authFetch({
      url: "export-pp5/getCheckTimeSubjectPP5By",
      method: "POST",
      body: JSON.stringify(data),
    });
    getCheckTimeSummaryPP5By = (data) =>
    this.authFetch({
      url: "export-pp5/getCheckTimeSummaryPP5By",
      method: "POST",
      body: JSON.stringify(data),
    });
}
